import React, {Component} from 'react';
import { Container, Row, Col, Tab, Nav, Form, Button, Spinner} from "react-bootstrap";
import { FaSave, FaRegTrashAlt, FaArrowLeft } from 'react-icons/fa';
import { Link } from 'react-router-dom';

import Side from "./Sidebar";
import Top from "./Topbar";
import Crypt from '../lib/Crypt';
import Loader from "./LoaderModal";
import swal from 'sweetalert';
import C from '../lib/Config';

const valuesArr = [
    { key: Crypt.getUniqueKey('-1'), id: '0', label: '- Select Value -' },
    { key: Crypt.getUniqueKey('0'), id: 'A', label: 'Alphanumeric' },
    { key: Crypt.getUniqueKey('1'), id: 'N', label: 'Numeric' }, 
]

export default class AddLabTestParameter extends Component {
    constructor(props) {
        super(props);
        this.state = { reportParamName: '', reportParamDesc: '', values: '', unitName:'', unitId:'', 
        reportParamId: 0, redirect : false, unitMasterArr: []  };
        this.handleChange = this.handleChange.bind(this); 
    }
    
    componentDidMount() {
        this.getAllUnits();
        if(this.props.location && this.props.location.search){
            let reportParamId = this.props.location.search.slice(3);
            this.setState({ reportParamId: reportParamId });
            this.getReportParameterDetails(reportParamId);
        }
    }

    handleChange(event){
        if(event.target.name === 'reportParamName'){
            this.setState({reportParamName: event.target.value});
        }
        if(event.target.name === 'values'){
            this.setState({values: event.target.value});
        }
        if(event.target.name === 'reportParamDesc'){
            this.setState({reportParamDesc: event.target.value});
        }
    } 

    getAllUnits() {
        return fetch(C.getUrl() + '/unitMst/allUnits')
        .then(res => res.json())
        .then(res => {
            let data = JSON.parse(res.message);
            var arr = [];
            data.map((item, index) => {
                let jsonList = new Object();
                jsonList['key'] = Crypt.getUniqueKey(index);
                jsonList['id'] = item.selectionId;
                jsonList['label'] = item.selectionValue;
                jsonList['scheduleDays'] = item.additionalValue;
                arr.push(jsonList);
            });
            this.setState({ unitMasterArr: arr });
        })
        .catch(err => {
            swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, });
        });
    }

    getReportParameterDetails(reportParamId){
      return fetch(C.getUrl() + '/reportParamMst/'+reportParamId, {
          method: 'GET',
          mode: 'cors',
      })
      .then(res => res.json())
      .then(res => {
          let resObj = res;
          let error = resObj.subErrors;
          if (error !== 'undefined' && error !== null && error !== "") {
              alert(error);
          } else {
              let obj = resObj.message;
          if (obj === 'No record found.') {
            
          } else {
              let data = JSON.parse(resObj.message);
              console.log(data);
              this.setState({ reportParamId: data.reportParamId }); 
              this.setState({ reportParamName: data.reportParamName }); 
              this.setState({ reportParamDesc: data.reportParamDesc }); 
              this.setState({ values: data.dataType }); 
            }
          }
      })
      .catch(err => {
          console.log("Error : " + err);
      });
    }

    saveReportParameter(event){
        let data = {
            reportParamId: this.state.reportParamId,
            reportParamName: this.state.reportParamName,
            reportParamDesc: this.state.reportParamDesc,
            dataType: this.state.values,
            activeInd: 'Y',
            unitMstDto: {
                unitId: this.state.unitId,
                unitName: this.state.unitName
            },
            createdDt: new Date(),
            updatedDt: new Date(),
            createdByIdUser: {
                userId: localStorage.getItem('userId')
            },
            updatedByIdUser: {
                userId: localStorage.getItem('userId')
            }
        }
        return fetch(C.getUrl() + '/reportParamMst/saveUpdate', {
            method: 'POST',
            mode: 'cors',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(res => res.json())
        .then(res => {
            let obj = res;
            let error = obj.subErrors;
            if (error !== null && error !== "") {
                swal({ title: "Warning!", text: "Error : " + error, icon: "error", buttons: false, timer: 2000, });
            } else {
                this.setState({ saveLoader: true });
                setTimeout(() => { this.setState({ saveLoader: false }) }, 3000)
                swal({ title: obj.message, icon: "success", buttons: false, timer: 2000, });
                setTimeout(() => { this.setState({ key: 'fourth'}) }, 4000)
                this.setState({ redirect : true });
            }
        })
        .catch(err => {
                swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, });
        });
    }

    render() {
        const { unitMasterArr  } = this.state;
        const _this = this;
        const { redirect } = this.state;
        return (
            <div className="d-flex" id="wrapper">
                {<Side />}
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        {<Top />}
                        <Container fluid>
                            <div className="app-content">
                                <section className="section">
                                    <Link to="/LabTestParameterMaster" className="btn btn-light"><FaArrowLeft className='fs-18' size='2.0rem' style={{verticalAlign: 'baseline'}}/> </Link> 
                                    <h3 className="fs-18 ml-3 header_title text-black mb-4">Add Lab Test Parameter</h3>
                                    <div className="dropdown-divider pb-2"></div>
                                    <Form.Group as={Row}>
                                        <Form.Label column sm="3"> Report Parameter Name </Form.Label>
                                        <Col sm="9">
                                            <Form.Control type='text' placeholder='' name='reportParamName' onChange={this.handleChange} value={this.state.reportParamName} />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row}>
                                        <Form.Label column sm="3"> Unit </Form.Label>
                                        <Col sm="9">
                                            <Form.Control as="select" id="" name='unit' value={this.state.unit} onChange={this.handleChange}>
                                                {
                                                    unitMasterArr.map((item, i) => {
                                                        return (
                                                            <option key={item.key} value={item.id}>{`${item.label}`}</option>
                                                        );
                                                    })
                                                }
                                            </Form.Control>
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row}>
                                        <Form.Label column sm="3"> Values </Form.Label>
                                        <Col sm="9">
                                            <Form.Control as="select" id="" name='values ' value={this.state.values } onChange={this.handleChange}>
                                                {
                                                    valuesArr.map((item, i) => {
                                                        return (
                                                            <option key={item.key} value={item.id}>{`${item.label}`}</option>
                                                        );
                                                    })
                                                }
                                            </Form.Control>
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row}>
                                        <Form.Label column sm="3"> Report Parameter Description </Form.Label>
                                        <Col sm="9">
                                            <Form.Control as='textarea' placeholder='' maxLength='65535' rows={2} name='reportParamDesc' onChange={this.handleChange} value={this.state.reportParamDesc} />
                                        </Col>
                                    </Form.Group> 
                                    <Row>
                                        <Col lg='12'>
                                            <div className="form-button text-center">
                                                <Button type="button" className="btn pt-2 pb-2 btn-secondary" onClick={this.saveReportParameter.bind(this)}>
                                                    {this.state.saveLoader && (
                                                        <Spinner className='mr-3' animation='border' size='1.5rem' />
                                                    )}
                                                    {!this.state.saveLoader && (
                                                        <FaSave className='mr-2' size='1.5rem' style={{ verticalAlign: "sub" }} />
                                                    )}
                                                    Save
                                                </Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </section>
                            </div>
                        </Container>
                    </div>
                </div>
            </div>
        )
    }
}